'use client';

import { useTranslation } from '@/hooks/useTranslation';
import React from 'react';
import { Spinner } from 'react-bootstrap';

type Props = {
  locale: string;
};

const LoadingComponent = ({ locale }: Props) => {
  const { t } = useTranslation(locale);

  return (
    <div className="d-flex  justify-content-center align-items-center flex-column">
      <div className="tw-absolute top-50 d-flex  justify-content-center align-items-center flex-column">
        <Spinner animation="border" variant="success" />
        <div>
          <span className="fs-5 fw-light">{t('LoadingComponent/text')}</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingComponent;
